<template>
  <div>
    <v-date-picker v-model="date"></v-date-picker>
    <div>{{ date }}</div>
    <div>{{ output }}</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      date: null
    }
  },
  computed: {
    output () {
      return this.date ? new Date(this.date).getTime() / 1000 : null
    }
  }
}
</script>
